import {
  LoMode,
  UpdateAnalyzerDto,
  SnapshotMarkerDelta,
  SnapshotSpectralMask,
  SnapshotMarker,
  SnapshotMonitor,
  MinMaxEnabled,
  SnapshotThreshold,
} from 'types';

export interface UpdateAnalyzer extends UpdateAnalyzerDto {
  id: number;
}

export enum AnalyzerMode {
  LIVE = 0,
  POLLING = 1,
}

export type SnapshotClone = {
  uuid: string;
  port: number;
  switch_port?: number;
  name: string;
  center: string;
  span: string;
  reference: number;
  scale: number;
  rbw: string;
  vbw: string;
  atten: string;
  preamp: number;
  lo: string;
  lo_mode: LoMode;
  inverted?: boolean;
  minmax_enabled?: MinMaxEnabled;
  detection_mode: number;
  crosspol_snapshot_id?: number | null;
  extra_wait_time?: number;
  analyzer_id: number;
  satellite_id: number;
  average_amount?: number;
  enabled?: boolean;
  crosspol_adjustment?: number;
  temporarily_disabled?: boolean;
  sweep_time_mode?: number;
  manual_sweep_time?: string;
  recording_locked?: boolean;
};

export type SnapshotTraceHistoryCombination = {
  id: number;
  uuid?: string;
  port: number;
  switch_port?: number;
  name?: string;
  center: string;
  span: string;
  reference: number;
  scale?: number;
  rbw: string;
  vbw: string;
  atten: string;
  preamp: number;
  lo: string;
  lo_mode: LoMode;
  inverted?: boolean;
  baseline_trace?: string | null;
  minmax_enabled?: MinMaxEnabled;
  min_trace?: string;
  max_trace?: string;
  detection_mode: number;
  crosspol_snapshot_id?: number | null;
  crosspol_adjustment?: number;
  last_updated?: string;
  last_trace?: Buffer;
  extra_wait_time?: number;
  analyzer_id: number;
  satellite_id: number;
  baseline_enabled?: boolean;
  average_amount?: number;
  enabled?: boolean;
  trace?: string;
  time?: string;
  sweep_time_mode?: number;
  last_reported_sweep_time?: string;
  manual_sweep_time?: string;
  monitors?: SnapshotMonitor[];
  masks?: SnapshotSpectralMask[];
  markers?: SnapshotMarker[];
  thresholds?: SnapshotThreshold[];
  snapshot_marker_delta?: SnapshotMarkerDelta[];
  snapshot_id?: number;
  temporary_snapshot_id?: number | null;
  lock_user_id?: number | null;
  needs_validated?: boolean;
};

export type AnalyzerSwitchGroup = {
  analyzerId: number;
  switchId: number;
  analyzerPort: number;
};
